/**
 * useHasManagementAccess – Check of gebruiker toegang heeft tot de Management module.
 * Toegang = Management tier OF Admin/Owner rol.
 * Gebruikt voor: Expert Mode (CFO-Stack), Overhead, Onvoorzien, Fabricatie-breakdown.
 */

import { useAuthStore } from '../stores/authStore'
import { useTenantTier } from './useTenantTier'

/**
 * @returns {{ hasManagementAccess: boolean, isLoading: boolean }}
 */
export function useHasManagementAccess() {
  const user = useAuthStore((state) => state.user)
  const { hasTier, isLoading } = useTenantTier()

  const hasManagementAccess =
    !!user &&
    (user.is_admin ||
      user.is_superuser ||
      !user.tenant_id ||
      String(user?.role || '').toUpperCase() === 'ADMIN' ||
      String(user?.role || '').toUpperCase() === 'OWNER' ||
      hasTier('MANAGEMENT'))

  return {
    hasManagementAccess: !!hasManagementAccess,
    isLoading: !!user && isLoading,
  }
}
